/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getProductChargesAsync } from './DataService/DataActionExtension.g';
import { IGetProductChargesResponse } from './DataService/DataServiceEntities.g';

/**
 * GetProductCharges Input Action
 */
export class GetProductChargesInput implements IActionInput {
    public itemIds: string[];
    public customerAccountNumber: string;
    public quantity: number;

    constructor(itemIds: string[], customerAccountNumber: string, quantity: number) {
        this.itemIds = itemIds;
        this.customerAccountNumber = customerAccountNumber;
        this.quantity = quantity;
    }

    public getCacheKey = () => `ProductCharges-${this.itemIds.join(',')}-${this.customerAccountNumber}-${this.quantity}`;
    public getCacheObjectType = () => 'ProductCharges';
    public dataCacheType = (): CacheType => 'request';
}

const createInput = (args: ICreateActionContext, itemIds: string[], customerAccountNumber: string, quantity: number): IActionInput => {
    return new GetProductChargesInput(itemIds, customerAccountNumber, quantity);
};

export async function getProductChargesAction(input: GetProductChargesInput, ctx: IActionContext): Promise<IGetProductChargesResponse> {
    return getProductChargesAsync({ callerContext: ctx }, input.itemIds, input.customerAccountNumber, input.quantity)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-product-charges] Unable to load product charges');
            throw new Error('[get-product-charges] Unable to load product charges');
        });
}

export default createObservableDataAction({
    action: <IAction<IGetProductChargesResponse>>getProductChargesAction,
    id: 'GetProductCharges',
    input: createInput
});
